import { Typography } from "@mui/material";
import { Brand } from "app/components";
import { useAuthContext } from "app/contexts/auth";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Collapse, Nav, Navbar, NavbarToggler, NavItem } from "reactstrap";

const links = [
  // { to: "dashboard", label: "Dashboard" },
  // { to: "solicitudes", label: "Solicitudes de inscripción" },
  { to: "empresas", label: "Empresas" },
  // { to: "admin", label: "Administración" },
  // { to: "profile", label: "Perfil" },
];

const initialState = false;

export function MainNavigation() {
  const auth = useAuthContext();
  // const {} = useProfileContext();

  const [isOpen, setOpen] = useState(initialState);

  function handleToggle() {
    setOpen((isOpen) => !isOpen);
  }

  function close() {
    setOpen(initialState);
  }

  return (
    <Navbar expand="md" color="primary" dark sticky="top">
      <NavLink to="." className="navbar-brand">
        <Brand />
      </NavLink>

      <NavbarToggler onClick={handleToggle} />

      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto" navbar>
          {auth.isAuthenticated &&
            links.map((link, index) => (
              <NavItem key={index} onClick={close}>
                <NavLink to={link.to} className="nav-link">
                  <Typography>{link.label}</Typography>
                </NavLink>
              </NavItem>
            ))}
        </Nav>
      </Collapse>
    </Navbar>
  );
}
